import * as React from 'react';

import classNames from 'classnames';
import type { IColorModifier } from '../ColorHelper';
import { getColorModifierClasses } from '../ColorHelper';

interface ILabelProps extends IColorModifier {
	className?: string;
}

export default class Label extends React.Component<ILabelProps, {}> {
	public render() {
		const { className } = this.props;

		const classes = classNames(
			'label',
			className ? className : '',
			getColorModifierClasses(this.props)
		);

		return <label className={classes}>{this.props.children}</label>;
	}
}
